<template>
    <form method="GET" @submit.prevent="submit">
        <b-container fluid class="pb-5">
            <b-row>
                <b-col cols="12">
                    <admin-card class="mb-3" :customStyle="customStyle">
                        <template v-slot:header>
                            <div class="vault-header">
                                <div class="vault-title">VAULT DETAIL</div>
                                <div style="display: flex">
                                    <div class="vault-filter">
                                        <admin-button
                                            color="green"
                                            :loading="loading"
                                        >
                                            Create
                                        </admin-button>
                                        <admin-button outline>
                                            Cancel
                                        </admin-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <b-container fluid>
                            <b-row>
                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">Chain</div>
                                    <div class="text-body">
                                        <b-form-select
                                            class="custom-input"
                                            v-model="form.network"
                                            :options="optChain"
                                            @change="changeNetwork()"
                                        ></b-form-select>
                                    </div>
                                </b-col>
                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">Token</div>
                                    <div class="text-body">
                                        <b-form-select
                                            v-model="form.vault_token_id"
                                            class="custom-input"
                                        >
                                            <option
                                                v-for="(item, index) in option"
                                                :key="index"
                                                v-bind:value="item.id"
                                            >
                                                {{ item.symbol.toUpperCase() }}
                                            </option>
                                        </b-form-select>
                                    </div>
                                </b-col>

                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">Type</div>
                                    <div class="text-body">
                                        <b-form-select
                                            class="custom-input"
                                            v-model="form.type"
                                            :options="optType"
                                        ></b-form-select>
                                    </div>
                                </b-col>
                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">
                                        Accent Colours
                                    </div>
                                    <div class="text-body">
                                        <b-form-select
                                            class="custom-input"
                                            v-model="form.accent"
                                            :options="optColor"
                                        ></b-form-select>
                                    </div>
                                </b-col>
                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">
                                        Time Period
                                    </div>
                                    <div class="text-body">
                                        <b-form-select
                                            class="custom-input"
                                            v-model="form.time_period"
                                            :options="optPeriod"
                                        ></b-form-select>
                                    </div>
                                </b-col>

                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">
                                        Max Deposits Accepted (USD)
                                    </div>
                                    <div class="text-body">
                                        <b-form-input
                                            type="number"
                                            class="custom-input"
                                            v-model="form.max_deposit"
                                        ></b-form-input>
                                    </div>
                                </b-col>

                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">
                                        Contract Address
                                    </div>
                                    <div class="text-body">
                                        <b-form-input
                                            class="custom-input"
                                            v-model="form.contract_address"
                                        ></b-form-input>
                                    </div>
                                </b-col>

                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">State</div>
                                    <div class="text-body">
                                        <b-form-select
                                            class="custom-input"
                                            v-model="form.state"
                                            :options="optState"
                                        ></b-form-select>
                                    </div>
                                </b-col>

                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">
                                        Sub-State
                                    </div>
                                    <div class="text-body">
                                        <b-form-select
                                            class="custom-input"
                                            v-model="form.sub_state"
                                            :options="optSubState"
                                        ></b-form-select>
                                    </div>
                                </b-col>

                                <b-col cols="4" class="box-list-data p-0 mb-3">
                                    <div class="text-head mb-2 pl-2">
                                        IL Vault
                                    </div>
                                    <div class="text-body">
                                        <b-form-checkbox
                                            v-model="form.is_il"
                                            switch
                                        >
                                            <span v-if="form.is_il">YES</span>
                                            <span v-else>NO</span>
                                        </b-form-checkbox>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </admin-card>

                    <card class="flex-wrap mb-3" customClass="card-vault-edit">
                        <template #header>
                            <div
                                class="header-vault-edit justify-content-between flex-wrap"
                            >
                                <div class="card-title">Strategy</div>
                            </div>
                        </template>
                        <div class="w-100">
                            <b-form-textarea
                                id="textarea-box"
                                placeholder="Enter text here"
                                rows="4"
                                v-model="form.strategy"
                            >
                            </b-form-textarea>
                        </div>
                    </card>

                    <card class="flex-wrap mb-3" customClass="card-vault-edit">
                        <template #header>
                            <div
                                class="header-vault-edit justify-content-between flex-wrap"
                            >
                                <div class="card-title">Withdrawals</div>
                            </div>
                        </template>
                        <div class="w-100">
                            <b-form-textarea
                                id="textarea-box"
                                placeholder="Enter text here"
                                rows="4"
                                v-model="form.withdrawals"
                            >
                            </b-form-textarea>
                        </div>
                    </card>

                    <card class="flex-wrap mb-3" customClass="card-vault-edit">
                        <template #header>
                            <div
                                class="header-vault-edit justify-content-between flex-wrap"
                            >
                                <div class="card-title">Risk</div>
                            </div>
                        </template>
                        <div class="w-100">
                            <b-form-textarea
                                id="textarea-box"
                                placeholder="Enter text here"
                                rows="4"
                                v-model="form.risk"
                            >
                            </b-form-textarea>
                        </div>
                    </card>
                </b-col>
            </b-row>
        </b-container>
    </form>
</template>
<script>
import AdminCard from "../../../components/Admin/UI/AdminCard.vue";
import AdminButton from "../../../components/Admin/UI/Button/AdminButton.vue";
import Card from "../../../components/Card.vue";

export default {
    components: {
        AdminCard,
        AdminButton,
        Card
    },
    data() {
        return {
            customStyle: {
                padding: "10px 20px",
                borderRadius: "4px"
            },
            optToken: [
                { value: 1, text: "wETH" },
                { value: 2, text: "wBTC" }
            ],
            optTokenBsc: [
                { value: 1, text: "DOGE" },
                { value: 2, text: "ADA" }
            ],
            optType: [
                { value: "put_selling", text: "Put Selling" },
                { value: "covered_call", text: "Covered Call" }
            ],
            optChain: [
                { value: "eth", text: "ETH" },
                { value: "bsc", text: "BSC" },
                { value: "ftm", text: "FTM" },
                { value: "matic", text: "MATIC" }
            ],
            optNut: [
                { value: "acorn", text: "Acorn" },
                { value: "walnut", text: "Walnut" },
                { value: "almond", text: "Almond" }
            ],
            optColor: [
                { value: "green", text: "Green" },
                { value: "orange", text: "Orange" },
                { value: "blue", text: "Blue" },
                { value: "red", text: "Red" }
            ],
            optPeriod: [
                { value: "daily", text: "Daily" },
                { value: "weekly", text: "Weekly" },
                { value: "biweekly", text: "BiWeekly" },
                { value: "monthly", text: "Monthly" }
            ],
            optState: [
                { value: "live", text: "Live" },
                { value: "draft", text: "Draft" },
                { value: "mature", text: "Mature" },
                { value: "archive", text: "Archive" }
            ],
            optSubState: [{ value: 1, text: "Open For Deposit" }],
            form: {
                vault_token_id: 1,
                type: "put_selling",
                nut: "acorn",
                accent: "green",
                chain_id: null,
                network: null,
                time_period: "weekly",
                contract_address: "",
                max_deposit: "",
                state: "live",
                sub_state: 1,
                strategy: null,
                withdrawals: null,
                risk: null,
                is_il: false
            },
            loading: false,
            option: null
        };
    },
    mounted() {
        this.form.chain_id = localStorage.chainId;
        //
    },
    methods: {
        changeNetwork() {
            let token = this.form.network;
            axios.get(`/api/admin/tokens/${token}`).then(res => {
                this.option = res.data;
            });
        },
        submit() {
            this.loading = true;
            this.$store
                .dispatch("API", {
                    url: "/api/vault",
                    method: "post",
                    ...this.form
                })
                .then(result => {
                    this.$router.push(`/admin/vaultdetail/${result.id}`);
                })
                .finally(() => (this.loading = false));

            // .finally(() => (this.loading = false));
        }
    }
};
</script>

<style lang="scss" scoped>
@import "./resources/sass/app.scss";

.vault-header {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    padding: 10px 0;
    border-bottom: 1px solid rgba(234, 237, 240, 1);
}

.vault-title {
    font-family: "Exo";
    font-size: 20px;
    font-weight: bold;
}

.vault-filter {
    padding-left: 20px;
    border-left: 1px solid rgba(234, 237, 240, 1);
    display: flex;
    gap: 4px;
}

.card-vault-edit {
    border: 1px solid #eaedf0 !important;
    border-radius: 4px !important;
    background: $primary-4;

    .header-vault-edit {
        border-bottom: 1px solid #eaedf0;
        padding-bottom: 13px;
        margin-bottom: 15px;
        width: 100%;
        display: flex;
    }
    .card-title {
        font-style: normal;
        font-weight: 900;
        font-size: 20px;
        line-height: 27px;
        //letter-spacing: 0.04em;
        text-transform: uppercase;
        color: $primary-5;
        margin: auto 0;
    }
    .btn-vault-save {
        width: 136px;
        height: 34px;
        border-radius: 4px !important;
        font-family: Exo !important;
        font-weight: bold !important;
        font-size: 12px !important;
        line-height: 16px !important;
        text-transform: uppercase;
        background: #27ae60 !important;
        &.edit {
            color: #27ae60 !important;
            background: $primary-4 !important;
            border: 1px solid #27ae60 !important;
        }
    }
    .box-fixed-text {
        padding: 10px;
        min-height: 76px;
        font-family: Exo;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        color: $primary-5;
    }
    .form-control,
    .form-control:active,
    .form-control:focus,
    .form-control:disabled {
        display: block;
        width: 100%;
        min-height: 76px; //max-content;
        padding: 10px;
        font-family: Exo;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        color: $primary-5;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #b9b9b9;
        border-radius: 4px;
        box-sizing: border-box;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
}
.custom-input,
.custom-input:focus {
    width: 92%;
    height: 100%;
    min-height: 38px;
    color: #222222;
    padding: 8px 10px;
    font-family: Exo;
    font-style: normal;
    font-weight: 900;
    font-size: 16px;
    line-height: 18px;
    text-transform: capitalize;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #b9b9b9;
    box-shadow: none !important;
    outline: none !important;

    &.custom-select {
        background: url("/icon/chevron-down.svg") no-repeat right 0.75rem
            center/8px 10px;
    }

    option {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        border: 1px solid #b9b9b9;
    }
}
.text-head {
    font-family: "Exo";
    color: #222222;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    text-align: left;
}
</style>
